import { observable, action, runInAction } from 'mobx'
import { getHomeData, getRoleList } from '../routes/report/task_api'

class TaskStore {
    @observable homeData
    @observable roleList
    @observable task_id
    @observable task_team_id
    @observable bp_show

    @action
    changeHomeData = async () => {
        const data = await getHomeData()
        runInAction(() => {
            this.homeData = data
        })
    }

    @action
    changeRoleList = async (id) => {
        const data = await getRoleList(id)
        runInAction(() => {
            this.roleList = data
            // this.roleList = [25]
        })
    }

    @action
    changeTaskId = (task_id) => {
        this.task_id = task_id
    }

    @action
    changeTaskTeamId = (task_team_id) => {
        this.task_team_id = task_team_id
    }

    @action
    changeBpShow = (show) => {
        this.bp_show = show
    }

    constructor () {
        this.homeData = {}
        this.roleList = []
        this.task_id = null
        this.bp_show = false
        this.task_team_id = null
    }
}

export default new TaskStore()



// WEBPACK FOOTER //
// ./src/store/task.js